export const Environments = {
    Cognac: "COGNAC",
    Champagne: "CHAMPAGNE",
};
